import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseFormComponent } from '@shared/base.form-component';
import { ContactInfoDTO } from '@staff-app/models/termStaffContactInfoDTO';

@Component({
    selector: 'idp2-personal-info',
    templateUrl: './personal-info.component.html',
    styleUrls: ['./personal-info.component.scss']
})
export class PersonalInfoComponent extends BaseFormComponent implements OnInit {
    @Output() formReady = new EventEmitter<FormGroup>();
    @Input() contactInfo: ContactInfoDTO;
    @Input()
    set isParentSubmitted(val: boolean) {
        this.submitted = val;
    }

    personalInfoForm: FormGroup;

    constructor(private fb: FormBuilder) {
        super();
    }
    ngOnInit() {
        this.personalInfoForm = this.fb.group({
            firstName: [null, [Validators.required]],
            middleInitial: [null],
            lastName: [null, [Validators.required]],
            preferredName: null
        });

        this.loadData();

        this.myForm = this.personalInfoForm;
        this.formReady.emit(this.personalInfoForm);
    }
    private loadData() {
        if (this.contactInfo && this.submitted === false) {
            this.personalInfoForm.patchValue({
                firstName: this.contactInfo.firstName,
                middleInitial: this.contactInfo.middleInitial,
                lastName: this.contactInfo.lastName,
                preferredName: this.contactInfo.preferredName
            });
        }
    }
}
